import { Injectable } from "@angular/core";
import { CookieService } from 'ngx-cookie-service';
import * as moment from 'moment'; 
import { EnvironmentConfigService } from '../../../core/services/environment-config.service';

@Injectable({
  providedIn: "root"
})
export class UserStateService {
  constructor(
    private cookieService: CookieService,
    private environmentConfigService: EnvironmentConfigService
  ) {}

  /**
   * Checks if the user is blocked or not. If the cookie exist, but expired, it is removed.
   *
   * @returns {boolean}
   */

  isUserBlocked = () => {
    let isBlocked = false;
    /*const time = this.cookieService.get("nomad.noc.ng.state");
    if (time) {
      isBlocked = parseInt(time) > moment().valueOf();
      if (!isBlocked) {
        this.cookieService.delete("nomad.noc.ng.state");
      }
    }*/
    return isBlocked;
  };

  /**
   * Blocks the user and return the time when the user should be unblocked.
   *
   * @returns Unix epoch time when to unblock.
   */
  blockUser = () => {
    let endTime;
    /*endTime = moment().add(1, "minutes").valueOf();
    this.cookieService.set("nomad.noc.ng.state", endTime.toString(), {
      secure: this.environmentConfigService.get("secureCookies")
    });*/
    return endTime;
  };

  /**
   * An error has been returned from logging in.
   * Check if the user should be blocked.
   *
   * @param errorMsg
   */
  checkForUserBlock = (errorMsg: any) => {
    const shouldBeBlocked = errorMsg && errorMsg.data && errorMsg.data.errorDetails &&
      Array.isArray(errorMsg.data.errorDetails) &&
      errorMsg.data.errorDetails.indexOf("blocked") !== -1

    if (shouldBeBlocked) {
      this.blockUser();
    }
    return shouldBeBlocked;
  };
}
